import type { IntlShape } from 'react-intl'

export function formatOrderTileOccupancyLabel(
  intl: IntlShape,
  occupancy?: App.Occupants,
): string | undefined {
  const parts: Array<string> = []
  const children = (occupancy?.children ?? 0) + (occupancy?.infants ?? 0) + (occupancy?.teenagers ?? 0)

  if (occupancy?.adults) {
    parts.push(intl.formatMessage(
      {
        id: 'hd1_9T_9cOUVixrwCqmW',
        defaultMessage: '{count, plural, one {# Adult} other {# Adults}}',
        description: 'Pluralised adult count label for upcoming booking tile on chat page',
      },
      { count: occupancy.adults },
    ))
  }

  if (children) {
    parts.push(intl.formatMessage(
      {
        id: 'uBlTaX7aUuFZfXEiFAQi',
        defaultMessage: '{count, plural, one {# Child} other {# Children}}',
        description: 'Pluralised child count label for upcoming booking tile on chat page, including children, infants and teenagers',
      },
      { count: children },
    ))
  }

  return parts.length ? parts.join(', ') : undefined
}
